import config from 'constants/config'
import { CUDO_TRAVEL, TREATME_TRAVEL, DEALS_TRAVEL, SCOOPON_TRAVEL } from 'constants/brands'

const PREFIX_MAP: Record<App.BrandName, string> = {
  [CUDO_TRAVEL]: 'cu',
  [TREATME_TRAVEL]: 'tm',
  [DEALS_TRAVEL]: 'de',
  [SCOOPON_TRAVEL]: 'sc',
  luxuryescapes: '',
  lebusinesstraveller: '',
  leagenthub: '',
}

export function formatBrazeUserId(memberId: string) {
  // we need to add brand prefix only for white label brands
  const brandPrefix = PREFIX_MAP[config.BRAND]

  return brandPrefix ? `${brandPrefix}_${memberId}` : memberId
}
